import axios from "axios";
import * as Sentry from "@sentry/react";
import { getAuth } from "firebase/auth";

export const api = axios.create({
    baseURL: import.meta.env.VITE_API_URL,
    withCredentials: false,
    headers: {
        Accept: "application/json",
    },
});

api.interceptors.response.use(
    (response) => response,
    (error) => {
        const status = error.response?.status;

        // Ignore expected client errors
        if (
            status !== 401 &&
            status !== 403 &&
            status !== 400 &&
            status !== 422
        ) {
            Sentry.captureException(error, {
                tags: {
                    type: "api-error",
                },
                extra: {
                    url: error.config?.url,
                    method: error.config?.method,
                    status,
                    response: error.response?.data,
                },
            });
        }

        return Promise.reject(error);
    },
);

api.interceptors.request.use(async (config) => {
    const auth = getAuth();
    const user = auth.currentUser;

    if (user) {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
});

export default api;
